<template>
    <transition name="fade">
        <div
            v-if="visible"
            :class="[
                'visual-tooltip',
                tooltip.modify,
                {
                    'visual-tooltip_theme_flats': dataStep.step === 'flat',
                    'is-sold' : tooltip.status === 'sold',
                    'is-not-sale' : tooltip.status === 'notSale'
                },
                `is-${direction}`]"
            :style="[{'top': `${y}px`}, {'left': `${x}px`}]"
            ref="wrapper">

            <template v-if="tooltip.type === 'flats' && tooltip.status !== 'sold' && tooltip.status !== 'notSale'">
                <div class="visual-tooltip__header">
                    <img v-if="tooltip.render"
                         class="visual-tooltip__img"
                         :src="tooltip.render"
                         :alt="tooltip.title"
                    >
                    <div class="visual-tooltip__title">
                        {{ tooltip.title }}
                    </div>

                    <div v-if="tooltip.deadline" class="visual-tooltip__deadline">{{ tooltip.deadline }}</div>
                </div>

                <ul :class="['visual-tooltip__params', {'is-action': tooltip.action}]">
                    <li
                        v-for="item in tooltip.params"
                        :key="item.price"
                        :class="['visual-tooltip__params-item', {'is-disabled': item.disabled}]">

                        <div v-if="item.flats" class="visual-tooltip__sign">{{ item.flats }}</div>
                        <div v-if="item.amount >= 0" class="visual-tooltip__amount">{{ item.amount }}</div>
                        <div v-if="item.area" class="visual-tooltip__value">{{ item.area }} м<sup>2</sup></div>

                        <div
                            v-if="item.price && dataStep.step !== 'flat'"
                            class="visual-tooltip__value">
                            {{ convertPriceRank(item.price) }}
                        </div>

                        <div
                            v-if="item.price && dataStep.step === 'flat'"
                            class="visual-tooltip__value">
                            {{ convertPriceDigit(item.price) }}
                        </div>

                        <div
                            v-if="item.priceOld && dataStep.step === 'flat'"
                            class="visual-tooltip__value-old">
                            {{ convertPriceDigit(item.priceOld) }}
                        </div>

                        <div
                            v-if="item.isBooked && dataStep.step === 'flat'"
                            class="visual-tooltip__value is-booked">
                            Забронирована
                        </div>
                    </li>
                    <li>
                        <div v-if="tooltip.action" class="visual-tooltip__label action-label">
                            {{ tooltip.action }}
                        </div>
                    </li>
                </ul>
            </template>

            <template v-if="tooltip.type === 'flats' && tooltip.status === 'sold'">
                <div class="visual-tooltip__header">
                    <div class="visual-tooltip__title">
                        Продана
                    </div>
                </div>
            </template>

            <template v-if="tooltip.type === 'flats' && tooltip.status === 'notSale'">
                <div class="visual-tooltip__header">
                    <div class="visual-tooltip__title">
                        Не в продаже
                    </div>
                </div>
            </template>

            <template v-if="tooltip.type === 'infrastructure'">
                <div class="visual-tooltip__image j-object-fit">
                    <img :src="tooltip.image" :alt="tooltip.title">
                </div>
                <div class="visual-tooltip__title">{{ tooltip.title }}</div>
            </template>
        </div>
    </transition>
</template>

<style lang='scss'>
    @import "./Tooltip.scss";
</style>

<script>
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            visible  : false,
            tooltip  : false,
            direction: false,
            x        : 0,
            y        : 0
        };
    },

    computed: {
        ...mapGetters({
            dataStep: 'GET_DATA_STEP'
        })
    },

    watch: {
        tooltip() {
            this.$nextTick(() => {
                this.wrapper = this.$refs.wrapper;

                this.checkBorders();
                this.setX();
                this.setY();
            });
        }
    },

    mounted() {
        observer.subscribe('mouseoverTooltip', (data) => {
            this.insert(data);
        });

        observer.subscribe('mousemoveTooltip', (event) => {
            this.change(event);
        });

        observer.subscribe('mouseleaveTooltip', () => {
            this.remove();
        });

        observer.subscribe('mouseclickTooltip', () => {
            this.remove();
        });
    },

    methods: {
        insert(data) {
            this.direction = data.direction || 'over';
            this.offset = 40;

            this.getMouseCoords(data.event);
            this.setData(data);

            this.visible = true;
        },

        change(event) {
            this.getMouseCoords(event);
            this.checkBorders();
            this.setX();
            this.setY();
        },

        remove() {
            this.visible = false;
        },

        getMouseCoords(event) {
            this.mouseCoords = {
                X: event.pageX,
                Y: event.pageY
            };
        },

        setData(data) {
            const targetId = data.id;

            const currentData = data.elements.find((element) => {
                const id = element.id;

                return id === targetId ? element : false;
            });

            this.tooltip = {
                type  : data.type,
                modify: data.modify,
                ...currentData.tooltip
            };
        },

        checkBorders() {
            const halfWidth = 2;

            let mouseCoord = 0;
            let tooltipCoord = 0;

            // Не влезает по верхнему краю.
            const top = () => {
                mouseCoord = this.mouseCoords.Y;
                tooltipCoord = this.wrapper.offsetHeight + this.offset;

                return mouseCoord < tooltipCoord;
            };

            // Не влезает по правому краю.
            const right = () => {
                mouseCoord = window.innerWidth - this.mouseCoords.X;
                tooltipCoord = (this.wrapper.offsetWidth / halfWidth) + this.offset;

                return mouseCoord < tooltipCoord;
            };

            // Не влезает по левому краю.
            const left = () => {
                mouseCoord = this.mouseCoords.X;
                tooltipCoord = (this.wrapper.offsetWidth / halfWidth) - this.offset;

                return mouseCoord < tooltipCoord;
            };

            if (top()) {
                this.direction = 'under';
            }

            if (right()) {
                this.direction = 'left';
            }

            if (left()) {
                this.direction = 'right';
            }
        },

        setX() {
            const halfWidth = 2;

            switch (this.direction) {
                case 'over':
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
                case 'under':
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
                case 'left':
                    this.x = this.mouseCoords.X - this.wrapper.offsetWidth - this.offset;
                    break;
                case 'right':
                    this.x = this.mouseCoords.X + this.offset;
                    break;
                default:
                    this.x = this.mouseCoords.X - (this.wrapper.offsetWidth / halfWidth);
                    break;
            }
        },

        setY() {
            const halfHeight = 2;

            switch (this.direction) {
                case 'over':
                    this.y = this.mouseCoords.Y - this.wrapper.offsetHeight - this.offset;
                    break;
                case 'under':
                    this.y = this.mouseCoords.Y + this.offset;
                    break;
                case 'left':
                    this.y = this.mouseCoords.Y - (this.wrapper.offsetHeight / halfHeight);
                    break;
                case 'right':
                    this.y = this.mouseCoords.Y - (this.wrapper.offsetHeight / halfHeight);
                    break;
                default:
                    this.y = this.mouseCoords.Y - this.wrapper.offsetHeight - this.offset;
                    break;
            }
        },

        convertPriceRank(price) {
            if (Number(price)) {
                return `от\u00A0${Utils.convertToDigit(Utils.convertToRank(price, 1000000).toFixed(1))}\u00A0млн`;
            }

            return price;
        },

        convertPriceDigit(price) {
            if (Number(price)) {
                return `${Utils.convertToDigit(price)}\u00A0руб`;
            }

            return Utils.convertToDigit(price);
        }
    }
};
</script>
